import React, { useContext } from "react";
import { observer } from "mobx-react";

import { EventOffer, SportOffer } from "@gp/offer";
import { SportOfferContext } from "@gp/components";

import { EventTeamsInfo } from "./EventTeamsInfo";
import { AdditionalOfferLinkWrapper } from "./AdditionalOfferLinkWrapper";
import { LiveEventCurrentStats, LiveEventTimeAndScore } from "./live-event";

export const LiveEventInfo = observer(function LiveEventInfo(props: {
	event: EventOffer;
}) {
	const sport = useContext(SportOfferContext) as SportOffer;
	return (
		<>
			<AdditionalOfferLinkWrapper>
				<EventTeamsInfo event={props.event}>
					<LiveEventTimeAndScore sport={sport} event={props.event} />
				</EventTeamsInfo>
			</AdditionalOfferLinkWrapper>

			<LiveEventCurrentStats event={props.event} sport={sport} />
		</>
	);
});
